import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getAllDivisionsByEstateID,
    getAllCollectionTypesByoperationEntityID,
    getEmployeeSessionImageReportData,
    getAllNarrationsForDropDown
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getAllNarrationsForDropDown() {
    var narrationArray = [];
    const response = await CommonGet('/api/EmployeeSessionImageReport/GetAllNarations', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            narrationArray.push(item[1]["narration"]);
        }
    }
    return narrationArray;
}



async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetEstatesByGroupID', 'groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getAllDivisionsByEstateID(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetEveryDivisionsFromOperationEntitiyID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return divisionArray;
}

async function getAllCollectionTypesByoperationEntityID(operationEntityID) {
    var collectionTypeArray = [];
    const response = await CommonGet('/api/CollectionType/GetAllCollectionTypesByOperationEntityID', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            collectionTypeArray[item[1]["collectionTypeMasterID"]] = item[1]["collectionTypeName"]
        }
    }
    return collectionTypeArray;
}


async function getEmployeeSessionImageReportData(data) {
    var model = {
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        narration: parseInt(data.narration),
        date: data.date
    };
    const response = await CommonPost('/api/EmployeeSessionImageReport/GetReportData', null, model);
    return response.data;
}
